import React, { useEffect, useState } from 'react';
import axiosInstance from '@/lib/axiosInstance';
import { useToast } from '@/hooks/use-toast';
import Header from '@/components/Header';
import SubscriptionPlans from '@/components/SubscriptionPlans';
import CurrentPlan from '@/components/CurrentPlan';
import useDocumentTitle from '@/components/Helmet';
// If preferred, use react-razorpay to load script
// import { useRazorpay } from 'react-razorpay';

declare global {
  interface Window {
    Razorpay: any;
  }
}

const PLANS = [
  { code: 'P100', name: 'Starter 100', priceInPaise: 49900, quota: 100 },
  { code: 'P1000', name: 'Growth 1000', priceInPaise: 199900, quota: 1000 },
  { code: 'PUL', name: 'Primium 10000', priceInPaise: 999900, quota: 10000 },
];

export default function SellerPlans() {
  useDocumentTitle("Plans");
  const { toast } = useToast();
  const [quota, setQuota] = useState<any>(null);
  const [buying, setBuying] = useState('');

  useEffect(() => {
    loadQuota();
  }, []);

  async function loadQuota() {
    try {

      const { data } = await axiosInstance.get('/api/seller/quota');
      if (!data.success) {
        setQuota(data);
      }
      else {
        toast({
          variant: "destructive",
          title: "Error!",
          description: data.message,
        })
      }
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error!",
        description: "Something went wrong",
      })
    }
  }

  async function handleBuy(planCode: any) {
    try {
      setBuying(planCode);
      const { data } = await axiosInstance.post('/api/billing/order', { planCode });
      const { order, key, plan } = data;

      // Load Razorpay script if not present
      if (!window.Razorpay) {
        await new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.src = 'https://checkout.razorpay.com/v1/checkout.js';
          s.onload = resolve;
          s.onerror = reject;
          document.body.appendChild(s);
        });
      }

      const options = {
        key,
        amount: order.amount,
        currency: order.currency,
        name: 'Property Portal',
        description: `${plan.name} subscription`,
        order_id: order.id,
        handler: async function (response: any) {
          try {
            
            await axiosInstance.post('/api/billing/verify', {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });
            await loadQuota();
            // alert('Payment successful and plan activated.');
            toast({
              variant: "success",
              title: "Success!",
              description: "Payment successful and plan activated.",
            })
          } catch (error :any) {
            toast({
              variant: "destructive",
              title: "Error!",
              description: error.message,
            })            
          }
          // Verify on server
        },
        prefill: {},
        theme: { color: '#3399cc' },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (e: any) {
      toast({
        variant: "destructive",
        title: "Error!",
        description: e.message,
      })
    } finally {
      setBuying('');
    }
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <CurrentPlan quota={quota} />
        <br />

        <SubscriptionPlans PLANS={PLANS} handleBuy={handleBuy} buying={buying} />

      </section>
    </div>
  );
}
